import { CSSProperties } from 'react';

import UIConfig from '@/UIConfig.ts';

export const containerStyles: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%'
};

export const iconsContainerStyles: CSSProperties = {
  width: '98px',
  height: '98px',
  borderRadius: '60px',
  background: '#303031',
  position: 'relative',
  marginBottom: '15px'
};

export const dotRightTop: CSSProperties = {
  position: 'absolute',
  width: '10px',
  height: '10px',
  borderRadius: '5px',
  background: '#505050',
  right: '-25px',
  top: '12px'
};

export const dotLeftTop: CSSProperties = {
  position: 'absolute',
  width: '20px',
  height: '20px',
  borderRadius: '10px',
  background: '#505050',
  left: '-30px',
  top: '32px'
};

export const dotLeftBottom: CSSProperties = {
  position: 'absolute',
  width: '10px',
  height: '10px',
  borderRadius: '5px',
  background: '#505050',
  left: '-25px',
  top: '92px'
};

export const headerTextStyles: CSSProperties = {
  margin: '5px 0px 14px',
  color: '#fff',
  textAlign: 'center'
};

export const textStyles: CSSProperties = {
  margin: 0,
  fontSize: '15px',
  maxWidth: '90%',
  color: '#a6a7ab',
  textAlign: 'center'
};

export const buttonStyles: CSSProperties = {
  borderRadius: '20px',
  border: `1px solid #FDCB40`,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: '40px'
};

export const buttonTextStyles: CSSProperties = {
  fontSize: '15px',
  padding: '11px 18px',
  fontWeight: 'bold',
  color: '#FDCB40',
  fontFamily: UIConfig.Fonts.Primary
};

export const completeProfileButtonStyles: CSSProperties = {
  borderRadius: '20px',
  display: 'flex',
  minWidth: '50%',
  minHeight: '40px',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: '30px',
  background: '#fff',
  cursor: 'pointer'
};

export const completeProfileButtonTextStyles: CSSProperties = {
  fontSize: '15px',
  padding: '11px 18px',
  fontWeight: 'bold',
  color: '#851989',
  fontFamily: UIConfig.Fonts.Primary
};